<template>
    <!-- 
    1.화면ID      : MCF_SC_005
    2.화면명      : 영업기회 Quota 일괄등록
    3.작성자      : 김찬종 차장
    4.화면설명    : 회계년도별 영업대표의 목표금액을 일괄등록한다.
    5.Descrition : 2024.04.25 최초작성
    * A Copyright Notice : Copyright 2024 SNC.CO All rights reserved
    -->

  <div class="content-wrap">
    <div class="register-wrap">
      <div class="row">
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="회계년도">
              <template #end>
                <ElSelect v-model="state.searchParams.fiscal_year" :options="state.yearList"/>
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="영업대표">
              <template #end>
                <ElSelect v-model="state.searchParams.sales_ceo" :options="state.ceoList"/>
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <ElLabel name="엑셀 파일"/>
            <ExcelManage 
              v-show="true" 
              ref="excelManage"
              :headerKeys="state.excelHeaders" 
              @return="r => getExcelData(r)"
              class="form-control form-control-sm"/>
          </div>
        </div>
      </div>
    </div>
    <div class="text-end py-3">
      <ElButton type="search" @buttonClick="templateDownload()" style="padding:0.2rem 1.8rem !important">템플릿 다운로드</ElButton>
      <ElButton type="search" @buttonClick="doReset()" style="padding:0.2rem 1.8rem !important">초기화</ElButton>
    </div>
    <!-- 그리드 영역 시작 -->
    <div class="table-responsive table-list">
      <DataTable ref="quotaTable"
        :value="state.gridRowData"
        :rowClass="data=>data.incorrectData ? 'fc-red' : ''"
        >

          <template #empty> 엑셀 파일을 선택해 주세요 </template>
          <Column field="group_nm" header="분류" style="min-width:3rem;"></Column>
          <Column field="class_nm" header="Product" style="min-width:4rem"></Column>
          <Column field="qty_sum" header="Quota All" style="min-width:8rem; text-align:right;">
              <template #body="{ data, field }">
                  {{ formatCurrency(data[field]) }}
              </template>
          </Column>
          <Column field="prod_ratio" header="Ratio" style="min-width:3rem; text-align:right;">
            <template #body="{ data, field }">
                  {{ formatPercent(data[field]) }}
              </template>
          </Column>
          <!-- <Column field="sales_ceo_nm" header="영업대표" style="min-width:5rem">
            <template #body="{ }">
                {{ printSalesCeoNm() }}
            </template>
          </Column> -->
          <Column field="qty1" header="Q1" style="width:7rem; text-align:right;">
              <template #body="{ data, field }">
                  {{ formatCurrency(data[field]) }}
              </template>
          </Column>
          <Column field="qty2" header="Q2" style="width:7rem; text-align:right;">
              <template #body="{ data, field }">
                  {{ formatCurrency(data[field]) }}
              </template>
          </Column>
          <Column field="qty3" header="Q3" style="width:7rem; text-align:right;">
              <template #body="{ data, field }">
                  {{ formatCurrency(data[field]) }}
              </template>
          </Column>
          <Column field="qty4" header="Q4" style="width:7rem; text-align:right;">
              <template #body="{ data, field }">
                  {{ formatCurrency(data[field]) }}
              </template>
          </Column>
      </DataTable>
    </div>
    <!-- 그리드 영역 종료 -->
    <div class="text-end py-2">
      <ElButton type="primary" @buttonClick="doSave()">저장</ElButton>
    </div>
  </div>
</template>
<script setup>   
import {reactive,ref,onMounted,watch} from 'vue';
import ExcelManage    from '@/components/common/MCO_EX_001.vue';
import DataTable      from 'primevue/datatable';
import Column         from 'primevue/column';
import { useCodeStore } from '@/store/code'
import { useLoading } from '@/composable/Loading.js'
import { useUserStore } from '@/store/user';
const { setIsLoading } = useLoading()
const userStore = useUserStore()
const codeStore = useCodeStore()
const excelManage = ref();
const quotaTable = ref();
import { getLoadUsers } from '@/api/monthly';
import { quotaUpload,quotaSelect } from '@/api/quota';
import { ProdUpperId } from '@/api/prod';

onMounted(() => {
  getYearList();
  getSalesCeo();
  // quotaSearch()
  // ProdUpperIdCheck();
});



//변수 선언 영역 
const state = reactive({
  isSave : true,
  tmpGridRowData : [],
  gridRowData :[],
  excelHeaders : ['rev_id','group_nm','full_class_nm','class_nm','class_id','qty1','qty2','qty3','qty4'],
  searchParams : {
    fiscal_year   : '',
    sales_ceo   : ''
  },
  yearList : [],
  ceoList : [],
  rev_id : '',
  rootSummary : []
});

// watch
watch(() => state.searchParams.fiscal_year, (newValue, oldValue) => {
  if(newValue){
    ProdUpperIdCheck();
  }
 
})

/* 회계년도 목록 */
const getYearList = () => {
  let year = 2019; //시작년도
  const thisYear = new Date().getFullYear();
  const nextYear = thisYear + 7;

  state.yearList = [];
  while(year <= nextYear) {
    state.yearList.push({text: year+'년', value: year});
    year++;
  }

  state.searchParams.fiscal_year = thisYear;
};

/* 영업대표 목록 */
const getSalesCeo = async () => {
  try {
    setIsLoading(true)

    // 영업대표 목록 초기화
    state.ceoList = []; // 초기화 추가

    const res = await getLoadUsers({employee_id : userStore.user.employeeId,auth_grp_id : userStore.user.authGrpId})
    
    if(['ADMIN', 'E'].includes(userStore.user.authGrpId))  state.ceoList.push({ text: '전체', value: '' })

    //사용자 목록을 영업대표{text, value} 목록으로 변환
    res.rtn.forEach(user => {
      state.ceoList.push({ text: user.user_nm, value: user.employee_id })
    });
    //영업대표 목록 초기화
    state.searchParams.sales_ceo = state.ceoList[0].value;
  } catch (err) {
    console.error(err);
    alert("영업대표 초기화 에러가 발생하였습니다.");
  } finally {
    setIsLoading(false)
  }
}

/* 통화 양식 적용 */
const formatCurrency = (value) => {
  return new Intl.NumberFormat('ko-KR').format(value);
}

/* 비율 양식 적용 */
const formatPercent = (value) => {
  var option = {
    style: 'percent',
    minimumFractionDigits: 1
  };
  return new Intl.NumberFormat('ko-KR', option).format(value);
}


/* 엑셀 데이터 */
const getExcelData = (excel) => {
  if(excel.sheets){
    let lev1Nm = new Set(excel.sheets[0].map((item)=> item.group_nm))


    let sumList = {}
    lev1Nm.forEach((item)=>{
      sumList[item] = 0
    })

    state.isSave = true

    excel.sheets[0].forEach((item,index1)=>{
      item.fiscal_year = state.searchParams.fiscal_year
      item.sales_ceo = state.searchParams.sales_ceo

      excel.sheets[0].forEach((item2,index2)=>{
        if(index1 !== index2 && item.class_id === item2.class_id){
          item.incorrectData = true
          state.isSave = false
        }
      })

      if(!item.class_id || isNaN(item.qty1) || isNaN(item.qty2) || isNaN(item.qty3) || isNaN(item.qty4)){
        item.incorrectData = true
        state.isSave = false
      }
      

      item.qty_sum = isNaN(Number(item.qty1) + Number(item.qty2) + Number(item.qty3) + Number(item.qty4)) ? 0 : Number(item.qty1) + Number(item.qty2) + Number(item.qty3) + Number(item.qty4)
      sumList[item.group_nm] += item.qty_sum
    })

    excel.sheets[0].forEach((item)=>{
      item.prod_ratio = isNaN(Number(item.qty_sum) / Number(sumList[item.group_nm])) ? 0 : Number(item.qty_sum) / Number(sumList[item.group_nm])
    })

    if(!state.isSave){
      alert('중복 또는 데이터 형식에 맞지 않은 데이터가 있습니다.수정 후 다시 업로드해 주세요.')
    }
    state.gridRowData = excel.sheets[0]
  }
}

/* 저장 */
const doSave = async () => {
  try{
    setIsLoading(true)

    const isValid = validate();
    if(!isValid) {
      return;
    }

    const isConfirmed = confirm(`회계년도 ` +state.searchParams.fiscal_year+`년도 Quota할당을 진행하시겠습니까?`);
    
    if(isConfirmed) {
      state.gridRowData.forEach((item)=>{
        state.rootSummary.forEach((rootItem)=>{
          if(rootItem.class_id === item.class_id.substring(0,4)){
            
            rootItem.qty1 += item.qty1
            rootItem.qty2 += item.qty2
            rootItem.qty3 += item.qty3
            rootItem.qty4 += item.qty4
            rootItem.qty_sum += item.qty_sum
          }
        })
      })

      state.rootSummary.forEach((rootItem)=>{
        rootItem.prod_ratio = 1
      })

      let params = {
        quotaVOList : [...state.gridRowData,...state.rootSummary],
        fiscal_year : state.searchParams.fiscal_year,
        sales_ceo   : state.searchParams.sales_ceo
      }
      const res = await quotaUpload(params)
      alert(`저장되었습니다.`);
    }
  }catch(e){
    console.log(e);
    alert("등록에 실패했습니다.");
  }finally{
    setIsLoading(false)

  }
  
}

/** 입력값 유효성 체크 */
const validate = () => {
  let msg = codeStore.getCodeMsg('77777'); // 해당 항목은 필수 입력값입니다.

  if(!state.isSave){
    alert('누락되거나 데이터 형식에 맞지 않은 데이터가 있습니다.수정 후 다시 업로드해 주세요.')
    return false;
  }

  if(state.searchParams.fiscal_year == '') {
    alert("회계년도를 선택해주세요.")
    return false;
  } else if(state.searchParams.sales_ceo == '') {
    alert("영업대표를 선택해주세요.")
    return false;
  }

  let size = state.gridRowData.length;
  if(size === 0) {
    alert("데이터가 존재하지 않습니다.");
    return false;
  }

  return true;
}

/* 초기화 */
const doReset = () => {
  getYearList();
  getSalesCeo();
  excelManage.value.resetUploadFile();

  state.gridRowData = [];
}

async function quotaSearch(){
  state.rootSummary=[]
  try{
    setIsLoading(true)
    const res = await quotaSelect(state.searchParams)
    state.rev_id = [...res.rtn][0].rev_id
    state.tmpGridRowData = [...res.rtn].filter((item)=>{
        item.prod_ratio = 0
        item.qty1 = 0
        item.qty2 = 0
        item.qty3 = 0
        item.qty4 = 0
        item.qty_sum = 0
      if(item.lvl === '3'){
        return item
      }else if(item.lvl === '1'){
        state.rootSummary.push(item)
      }
    })
  }catch(e){
    console.log(e)
  }finally{
    setIsLoading(false)
  }

}

async function templateDownload(){
  await quotaSearch()
  let fileNm = '영업기회 Quota'
  let header = [
    {header : '버전', field : 'rev_id'},
    {header : '대분류', field : 'group_nm'},
    {header : '경로', field : 'full_class_nm'},
    {header : 'Product', field : 'class_nm'},
    {header : '상품 일련번호', field : 'class_id'},
    {header : 'Q1', field : 'qty1'},
    {header : 'Q2', field : 'qty2'},
    {header : 'Q3', field : 'qty3'},
    {header : 'Q4', field : 'qty4'},
  ]
  excelManage.value.excelDownload(fileNm, header, state.tmpGridRowData)
}

const ProdUpperIdCheck =async()=>{
  state.rootSummary=[]
  try{
    setIsLoading(true)
    const res = await ProdUpperId(state.searchParams)
    res.rtn.filter((item)=>{
      item.prod_ratio = 0
        item.qty1 = 0
        item.qty2 = 0
        item.qty3 = 0
        item.qty4 = 0
        item.qty_sum = 0
        item.lvl = 1
        state.rootSummary.push(item)
    })
  }catch(e){
    console.log(e)
  }finally{
    setIsLoading(false)
  }
}
</script>